
export default function TeamSection() {
  const team = [
    {
      name: 'Jerry Lee Jr',
      role: 'CEO & Founder',
      bio: '15+ years in tiny home construction and hospitality development with a passion for sustainable tourism and outdoor experiences. Founder of OED Tiny Homes and Glamping Retreat Developments.',
      image: 'https://public.readdy.ai/ai/img_res/177f5a300d9a37d8b7ac1767efc2887a.jpg',
      linkedin: '#'
    },
    {
      name: 'Michael Chen',
      role: 'Head of Development',
      bio: 'Former architect specializing in sustainable design and eco-friendly construction in natural environments.',
      image: 'https://readdy.ai/api/search-image?query=professional%20male%20architect%20and%20developer%2C%20outdoor%20business%20setting%2C%20construction%20and%20design%20background%2C%20sustainable%20development%20expert%2C%20confident%20and%20knowledgeable%20appearance%2C%20natural%20lighting&width=300&height=400&seq=team2&orientation=portrait',
      linkedin: '#'
    },
    {
      name: 'Emily Rodriguez',
      role: 'Investment Director',
      bio: 'Wall Street veteran with expertise in real estate investment and alternative asset management.',
      image: 'https://readdy.ai/api/search-image?query=professional%20female%20investment%20director%2C%20business%20attire%2C%20financial%20expertise%2C%20confident%20and%20analytical%20demeanor%2C%20modern%20office%20or%20outdoor%20business%20setting%2C%20investment%20industry%20professional&width=300&height=400&seq=team3&orientation=portrait',
      linkedin: '#'
    },
    {
      name: 'David Thompson',
      role: 'Operations Manager',
      bio: 'Luxury resort operations expert ensuring exceptional guest experiences across all properties.',
      image: 'https://readdy.ai/api/search-image?query=professional%20male%20operations%20manager%20in%20hospitality%20industry%2C%20outdoor%20resort%20setting%2C%20guest%20service%20focused%2C%20approachable%20and%20service-oriented%20demeanor%2C%20luxury%20hospitality%20background&width=300&height=400&seq=team4&orientation=portrait',
      linkedin: '#'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Leadership Team</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Meet the experienced professionals driving innovation in luxury outdoor hospitality
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {team.map((member, index) => (
            <div key={index} className="text-center group">
              <div className="relative mb-4 overflow-hidden rounded-lg">
                <img 
                  src={member.image}
                  alt={member.name}
                  className="w-full h-80 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-1">{member.name}</h3>
              <p className="text-emerald-600 font-semibold mb-3">{member.role}</p>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">{member.bio}</p>
              <a 
                href={member.linkedin}
                className="inline-flex items-center text-emerald-600 hover:text-emerald-700 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-line mr-2"></i>
                Connect
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
